import { render, staticRenderFns } from "./DetailedReceiptAndPayment.vue?vue&type=template&id=2f853ee1"
import script from "./DetailedReceiptAndPayment.vue?vue&type=script&lang=js"
export * from "./DetailedReceiptAndPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports